import { useContext } from "react";
import { useAssetCache } from "../context/AssetCacheContext";
import { LinkContext } from "../context/LinkContext";
import { PageContext } from "../context/PageContext";
import { SiteSettingsContext } from "../context/SiteSettingsContext";
import { LinkInfo } from "../models/shared/LinkInfo";
import { buildInternalUrl } from "../utilities/routes/urlBuilder";

const useUrl = (linkInfo: LinkInfo | undefined) => {
  const pageContext = useContext(PageContext);
  const { routeInfo } = useContext(SiteSettingsContext);
  const urlMap = useContext(LinkContext);
  const { getFileDetails, getImageDetails } = useAssetCache();

  if (!linkInfo) {
    return null;
  }

  let url: string | undefined;

  if (linkInfo.isExternalLink === true) {
    url = linkInfo.url;
  } else {
    if (!linkInfo.reference) {
      if (linkInfo.fileReference) {
        url =
          linkInfo.fileReference.url ||
          getFileDetails(linkInfo.fileReference._ref)?.url ||
          undefined;
      } else if (linkInfo.imageReference) {
        url =
          linkInfo.imageReference.url ||
          getImageDetails(linkInfo.imageReference._ref)?.url ||
          undefined;
      } else {
        // No reference? Add current language so that we can link to the correct home page
        linkInfo.reference = {
          i18nLang: pageContext.i18nLang
        };

        url = buildInternalUrl(linkInfo.reference, routeInfo);
      }
    } else {
      url = buildInternalUrl(linkInfo.reference, routeInfo, urlMap);
    }
  }

  if (linkInfo.anchor?.length) {
    let formattedAnchor = linkInfo.anchor;

    if (!formattedAnchor.startsWith("#")) {
      formattedAnchor = `#${formattedAnchor}`;
    }

    url += formattedAnchor;
  }

  return url;
};

export default useUrl;
